import { useQuery } from '@tanstack/react-query'
import { ClassDetailRes, ClassStudentRes } from '@/types/class.type'
import { axiosInstance } from '@/lib/axios'

interface ClassStudentParamsType {
  classId: string
  page: number
  limit: number
  search: string
}

export const getClassDetail = async (classId: string) => {
  return axiosInstance.get<ClassDetailRes>(`/class/${classId}`)
}

export const getClassStudents = async ({
  classId,
  page,
  limit = 10,
  search,
}: ClassStudentParamsType) => {
  return axiosInstance.get<ClassStudentRes>(`/class/${classId}/students`, {
    params: {
      page,
      limit,
      ...(search && { search }),
    },
  })
}

export const useGetClassDetail = (classId: string) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['classDetail', classId],
    queryFn: () => getClassDetail(classId),
    enabled: !!classId,
  })

  return {
    classDetail: data?.data,
    isLoadingClassDetail: isLoading,
    refetchClassDetail: refetch,
  }
}

export const useGetClassStudent = ({
  classId,
  page,
  limit = 10,
  search,
}: ClassStudentParamsType) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['classStudent', page, limit, search, classId],
    queryFn: () => getClassStudents({ page, limit, classId, search }),
  })

  return {
    students: data?.data.data,
    meta: data?.data.meta,
    isLoadingClassStudents: isLoading,
    refetchClassStudent: refetch,
  }
}
